// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"also-read-m__wrapper__2KFMz","content":"also-read-m__content__2FuPS","publication":"also-read-m__publication__wGCCA"};